import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import React from 'react';

import {styles} from './CreateDocumentModal.styles';
import {
  getAllowedPresentationFormats,
  isRollforwardFlow,
  presentationOptions,
} from './CreateDocumentModal.utils';

export const PriorPresentationFormatSelect = ({
  previousDocument,
  previousPresentationFormat,
  previousPresentationFormatTouched,
  setPreviousPresentationFormat,
  setPreviousPresentationFormatTouched,
}) => {
  return (
    <Stack>
      <Typography pb={1} style={styles.modal.label}>
        Prior presentation format *
      </Typography>
      <Select
        disabled={!!previousDocument?.presentationFormat}
        error={previousPresentationFormatTouched && !previousPresentationFormat}
        onBlur={() => {
          setPreviousPresentationFormatTouched(true);
          if (!previousPresentationFormat) {
            setPreviousPresentationFormat('');
          }
        }}
        onChange={(e) => {
          setPreviousPresentationFormat(e.target.value);
        }}
        onFocus={() => {
          if (!previousPresentationFormat) {
            setPreviousPresentationFormat('');
          }
        }}
        required
        sx={styles.modal.select}
        value={previousPresentationFormat}
      >
        {Object.entries(presentationOptions).map(([key, opt]) => (
          <MenuItem key={key} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </Select>
    </Stack>
  );
};

PriorPresentationFormatSelect.propTypes = {
  previousDocument: PropTypes.object,
  previousPresentationFormat: PropTypes.string.isRequired,
  previousPresentationFormatTouched: PropTypes.bool.isRequired,
  setPreviousPresentationFormat: PropTypes.func.isRequired,
  setPreviousPresentationFormatTouched: PropTypes.func.isRequired,
};

export const PresentationFormatSelect = ({
  createFlow,
  presentationFormat,
  presentationFormatTouched,
  previousPresentationFormat,
  setPresentationFormat,
  setPresentationFormatTouched,
}) => {
  const isRollforward = isRollforwardFlow(createFlow);
  const allowedFormats = isRollforward
    ? getAllowedPresentationFormats(previousPresentationFormat)
    : getAllowedPresentationFormats(null);

  return (
    <Stack>
      <Typography pb={1} style={styles.modal.label}>
        Presentation format *
      </Typography>
      <Select
        error={presentationFormatTouched && !presentationFormat}
        onBlur={() => {
          setPresentationFormatTouched(true);
          if (!presentationFormat) {
            setPresentationFormat('');
          }
        }}
        onChange={(e) => setPresentationFormat(e.target.value)}
        onFocus={() => {
          if (!presentationFormat) {
            setPresentationFormat('');
          }
        }}
        required
        sx={styles.modal.select}
        value={presentationFormat}
      >
        {Object.entries(presentationOptions).map(([key, opt]) => (
          <MenuItem
            disabled={!allowedFormats.includes(opt.value)}
            key={key}
            value={opt.value}
          >
            {opt.label}
          </MenuItem>
        ))}
      </Select>
    </Stack>
  );
};

PresentationFormatSelect.propTypes = {
  createFlow: PropTypes.string,
  presentationFormat: PropTypes.string.isRequired,
  presentationFormatTouched: PropTypes.bool.isRequired,
  previousPresentationFormat: PropTypes.string.isRequired,
  setPresentationFormat: PropTypes.func.isRequired,
  setPresentationFormatTouched: PropTypes.func.isRequired,
};
